// extracted by mini-css-extract-plugin
export default {"menuContainer":"SidebarMenu_menuContainer_Ik1kU"};